import axios from 'axios';
import { showFailToast } from 'vant';

/**
 * 配置Axios拦截器处理认证问题
 * @param {Function} onAuthError 认证错误处理函数
 */
export const setupAuthInterceptors = (onAuthError) => {
  // 添加请求拦截器
  axios.interceptors.request.use(
    config => {
      // 从localStorage获取token
      const token = localStorage.getItem('userToken');
      
      // 如果存在token，则添加到请求头
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
  
  // 添加响应拦截器
  axios.interceptors.response.use(
    response => response,
    error => {
      // 处理401未授权错误
      if (error.response && error.response.status === 401) {
        console.log('收到401响应，认证失败');
        
        // 显示登录失效提示
        showFailToast('登录已失效，请重新登录');
        
        // 清除localStorage中的用户数据
        localStorage.removeItem('userToken');
        
        // 调用传入的错误处理函数
        if (typeof onAuthError === 'function') {
          onAuthError(error);
        }
      }
      
      return Promise.reject(error);
    }
  );
};

/**
 * 为单个请求添加认证token
 * @param {string} token 认证token
 * @returns {Object} 包含认证头的配置对象
 */
export const getAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
}; 